import React, { useState } from "react"
import PropTypes from "prop-types"
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader,
  changeTopbarTheme,
  showRightSidebarAction,
  changeColor,
  changeMode,
  changeTheme,
} from "../store/actions"

import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import VerifiedIcon from "@mui/icons-material/Verified"
import ThemeToggle from "./toggle-theme"
import userImage from "../../src/assets/images/user.jpg"


const UserDropdown = props => {
  const [menu, setMenu] = useState(false)
  const userData = useSelector(state => state.Login.userData)
  console.log("userData", userData)
  const mode = useSelector(state => state.Layout.layoutMode)
  const dispatch = useDispatch()
  return (
    <Dropdown
      isOpen={menu}
      toggle={() => setMenu(!menu)}
      className="d-inline-block"
    >
      {/* 👇 Custom user block as DropdownToggle */}
      <DropdownToggle
        className="btn header-item waves-effect"
        id="page-header-user-dropdown"
        tag="div"
        style={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          padding: "5px 10px",
        }}
      >
        {/* Avatar */}
        <img
          src={userData.avatar || userImage}
          alt={userData.firstName}
          className="rounded-circle"
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />

        {/* User info */}
        <div style={{ marginLeft: "10px", textAlign: "left" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <h3
              className=" semibold-font inter"
              style={{
                fontSize: "16px",
                textTransform: "capitalize",
                margin: 0,
                color: mode === "dark" ? "#fff" : "#050409",
              }}
            >
              {userData.firstName} {userData.lastName}
            </h3>
            <VerifiedIcon
              style={{
                color: "#28C76F",
                marginLeft: "5px",
                fontSize: "18px",
              }}
            />
          </div>
          <p
            className=" inter"
            style={{
              textTransform: "capitalize",
              margin: 0,
              fontSize: "14px",
              color: mode === "dark" ? "#fff" : "#050409",
            }}
          >
            {userData.role}
          </p>
        </div>
      </DropdownToggle>

      {/* Dropdown content */}
      <DropdownMenu className="dropdown-menu-end">
        <div className="radio-toolbar" style={{ padding: "5px 20px" }}>
          <span className="mb-2 d-block">Theme</span>
          <input
            type="radio"
            id="radioLight"
            name="modetype"
            value="light"
            onChange={e => {
              if (e.target.checked) dispatch(changeMode(e.target.value))
            }}
          />
          <label
            htmlFor="radioLight"
            style={{
              backgroundColor: mode === "light" ? "#2990DF" : "",
              color: mode === "light" ? "#fff" : "",
            }}
          >
            Light
          </label>{" "}
          <input
            type="radio"
            id="radioDark"
            name="modetype"
            value="dark"
            onChange={e => {
              if (e.target.checked) dispatch(changeMode(e.target.value))
            }}
          />
          <label
            htmlFor="radioDark"
            style={{
              backgroundColor: mode === "dark" ? "#2990DF" : "",
              color: mode === "dark" ? "#fff" : "",
            }}
          >
            Dark
          </label>
        </div>
        <Link to="/logout" className="dropdown-item text-danger">
          <i className="mdi mdi-power font-size-17 text-muted align-middle me-1 text-danger" />
          <span>{props.t("Logout")}</span>
        </Link>
      </DropdownMenu>
    </Dropdown>
  )
}

UserDropdown.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(UserDropdown)),
)
